/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeedDto } from '../../models/feed-dto';

export interface FeedControllerFindAll$Params {
}

export function feedControllerFindAll(http: HttpClient, rootUrl: string, params?: FeedControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeedDto>>> {
  const rb = new RequestBuilder(rootUrl, feedControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeedDto>>;
    })
  );
}

feedControllerFindAll.PATH = '/api/feeds';
